const jobData = [
    {
    role: "Digital IC Design Engineer",
    locations: "Milpitas, CA",
    qualifications: "BE/ BTech/ MTech/MS/ PhD",
    disciplines: "Electrical Engineering, Electronics Engineering, Electronics & Communications Engineering, Computer Engineering, or related field",
    experience: "1+ years",
    modalIds: {
      jobDescriptionId: "DigitalJD_IC",
      expertiseModalId: "DigitalPE_IC",
    },
    summary: `We are seeking an ASIC/SoC Design Engineer with experience in RTL design and digital hardware development using Verilog/SystemVerilog. The ideal candidate will work on designing, debugging, and optimizing ASIC/SoC modules, collaborating with verification and physical design teams to ensure high-performance, power-efficient, and reliable semiconductor solutions.`,
    responsibilities: [
        "Design and develop RTL modules for ASIC/SoC designs using Verilog/System Verilog.",
        "Translate architectural specifications into synthesizable digital designs.",
        "Perform design trade-off analysis for performance, power, and area.",
        "Create and maintain design documentation and specifications.",
        "Debug design issues found during simulation, synthesis, and silicon validation.",
        "Run lint, CDC, and other design quality checks.",
        "Collaborate with verification engineers to achieve functional coverage.",
        "Integrate IP blocks and ensure proper interface functionality.",
        "Work with physical design teams on timing constraints and closure.",
        "Participate in design reviews and technical discussions.",
        "Support backend implementation and silicon bring-up activities.",
        "Support design and verification activities using standard engineering tools."
    ],
    qualificationsList: [
        "Bachelor’s degree or foreign academic equivalent in Electrical Engineering, Electronics Engineering, Electronics & Communications Engineering, Computer Engineering, or related field.",
        "Requires 12 months of experience in the job offered or as ASIC Design Engineer, RTL Design Engineer, FPGA Design Engineer, SoC Design Engineer, Hardware Design Engineer, or Associate Engineer - Digital Design, Engineering, or related field.",
        "Requires experience in Design Quality: Synopsys Spyglass, Synthesis: Cadence Genus, Design for Test: Modus, Place & Route: Innovus, Static Timing: Tempus, EMIR: Voltus, Circuits: Virtuoso, and Physical Verification: Siemens Calibre."
    ],
  },
  {
    role: "RTL Designer",
    locations: "India (Bhubaneswar, Bangalore & Ahmedabad – Onsite only), Philippines (Manila), Singapore, USA (Milpitas)",
    qualifications: "BE/ BTech/ MTech/MS/ PhD",
    disciplines: "Electronics, Electrical, Computer Engineering or Computer Science Engineering",
    experience: "5+ to 15+ years",
    modalIds: {
      jobDescriptionId: "DigitalJD_RTL",
      expertiseModalId: "DigitalPE_RTL",
    },
    summary: `We are seeking an experienced SoC Architect with deep expertise in high-speed interface technologies including PCIe, CXL, and Network-on-Chip (NoC) architectures. The ideal candidate will lead the architectural definition, implementation strategy, and technical direction for next-generation semiconductor products, ensuring optimal system performance, power efficiency, and functionality.`,
    responsibilities: [
      "Define and develop SoC architecture specifications with a focus on advanced interface technologies (PCIe Gen 5/6, CXL 2.0/3.0, custom NoC solutions)",
      "Create detailed micro-architectural specifications including block diagrams, interface definitions, and performance models",
      "Collaborate with IP teams to define and implement PCIe controllers, CXL interfaces, and custom NoC topologies",
      "Develop performance models and conduct analysis to optimize system throughput, latency, and power consumption",
      "Lead technical discussions with cross-functional teams including RTL designers, verification engineers, and physical design teams",
      "Identify architectural risks and develop mitigation strategies throughout the design lifecycle",
      "Evaluate and select third-party IP components when appropriate",
      "Participate in industry standard committees and stay current with emerging interface technologies",
      "Mentor junior architects and technical staff"
    ],
    qualificationsList: [
      "Bachelor's degree in Electrical Engineering, Computer Engineering, or related field (Master's or PhD preferred)",
      "At least 8+ years of experience in SoC architecture with specific focus on high-speed interconnect technologies",
      "Deep technical knowledge of PCIe (Gen 4/5/6) and CXL specifications and implementations",
      "Extensive experience designing and implementing Network-on-Chip architectures",
      "Proficiency in System Verilog and UVM for architecture modeling and verification",
      "Strong understanding of SoC performance analysis and optimization techniques",
      "Experience with cache coherency protocols and memory subsystem design",
      "Demonstrated ability to lead complex architectural decisions and trade-offs"
    ],
    expertiseList: [
      "Experience with PCIe and CXL switch design and implementation is an added advantage",
      "Experience with CXL 2.0/3.0 implementation and memory semantics",
      "Familiarity with emerging interface standards (UCIe, CCIX)",
      "Knowledge of AI/ML accelerator integration with high-speed interfaces",
      "Experience designing multi-die systems using advanced packaging technologies",
      "Expertise in power optimization techniques for complex SoCs",
      "Contribution to industry standards committees or publications",
      "Experience with high-performance computing, data center, or networking applications"
    ]
  },
  {
    role: "Senior Design Verification Engineer",
    locations: "India (Bangalore & Ahmedabad - Onsite only)",
    qualifications: "BE/ BTech/ MTech/MS/ PhD",
    disciplines: "Electronics, Electrical, Computer Engineering or Computer Science Engineering",
    experience: "5+ to 10+ years",
    modalIds: {
      jobDescriptionId: "DigitalJD_SeniorDV",
      expertiseModalId: "DigitalPE_SeniorDV"
    },
    summary: `We are looking for a highly skilled and experienced Design Verification Engineer to join our team. This role is ideal for someone who brings deep technical expertise in verification along with a strong grasp of industry protocols and low-power design techniques. You'll work on advanced IP and SoC subsystems involving both RISC-V and ARM-based architecture, and collaborate closely with our architecture, design, and validation teams.`,
    responsibilities: [
      "Own and drive the full verification cycle for IP blocks and subsystems",
      "Create detailed verification plans, identify test items, and track coverage",
      "Build UVM-based test benches from scratch, including drivers, monitors, and scoreboards",
      "Perform low power verification using both UPF and Native Low Power (NLP) methods",
      "Develop and run UVM-based test environments for Ethernet and other protocol interfaces",
      "Integrate and work with third-party Verification IPs (VIPs)",
      "Write and debug assertions and functional coverage models",
      "Collaborate with design and architecture teams to close verification cycles efficiently",
      "Support silicon bring-up and post-silicon debug when required",
      "Mentor junior team members on verification techniques and best practices"
    ],
    qualificationsList: [
      "Bachelor’s degree in Electrical Engineering, Electronics and Communications Engineering, Computer Engineering, Computer Science, or related fields",
      "Fluent in both written and spoken English",
      "Excellent collaborative skills",
      "Highly motivated and self-driven individual",
      "Strong coding and object-oriented programming skills",
      "Excellent debugging, problem solving, and analytical skills",
      "Knowledgeable in digital design",
      "Minimum 7 years of industry experience in Design Verification roles",
      "A track record of successfully verifying complex IP blocks or subsystems from spec to silicon"
    ],
    expertiseList: [
      "UPF / Low Power Verification (UVM expert)",
      "Strong understanding of low-power concepts in ASIC design (UPF/NLP) from a verification perspective",
      "UVM with Ethernet protocol expertise",
      "NLP Testbench Verification with Native Low Power (UVM expert)",
      "Strong command over System Verilog, Verilog, and UVM methodology",
      "Solid understanding of ASIC design flows and power-aware design concepts",
      "Experience with protocols like PCIe, AXI, CHI, Ethernet, USB, NVMe, DDR, and CXL",
      "Good working knowledge of System Verilog Assertions (SVA) and formal verification techniques",
      "Hands-on experience with scripting (Python, Perl, Shell, TCL)",
      "Comfortable working in Linux development environments",
      "Excellent debugging, problem-solving, and analytical thinking",
      "Strong communication and collaboration skills"
    ]
  },
  {
    role: "SoC Architect - High Speed Interface Specialist",
    locations: "India (Bhubaneswar), Philippines (Manila), Singapore, Malaysia",
    qualifications: "BE/ BTech/ MTech/MS/ PhD",
    disciplines: "Electronics, Electrical, Computer Engineering or Computer Science Engineering",
    experience: "10 – 25 Years",
    modalIds: {
        jobDescriptionId: "DigitalJD1",
        expertiseModalId: "DigitalPE1",
    },
    summary: `We are seeking an experienced SoC Architect with deep expertise in high-speed interface technologies including PCIe, CXL, and Network-on-Chip (NoC) architectures. The ideal candidate will lead the architectural definition, implementation strategy, and technical direction for next-generation semiconductor products, ensuring optimal system performance, power efficiency, and functionality.`,
    responsibilities: [
        "Define and develop SoC architecture specifications with a focus on advanced interface technologies (PCIe Gen 5/6, CXL 2.0/3.0, custom NoC solutions)",
        "Create detailed micro-architectural specifications including block diagrams, interface definitions, and performance models",
        "Collaborate with IP teams to define and implement PCIe controllers, CXL interfaces, and custom NoC topologies",
        "Develop performance models and conduct analysis to optimize system throughput, latency, and power consumption",
        "Lead technical discussions with cross-functional teams including RTL designers, verification engineers, and physical design teams",
        "Identify architectural risks and develop mitigation strategies throughout the design lifecycle",
        "Evaluate and select third-party IP components when appropriate",
        "Participate in industry standard committees and stay current with emerging interface technologies",
        "Mentor junior architects and technical staff"
    ],
    qualificationsList: [
        "Bachelor's degree in Electrical Engineering, Computer Engineering, or related field (Master's or PhD preferred)",
        "At least 8+ years of experience in SoC architecture with specific focus on high-speed interconnect technologies",
        "Deep technical knowledge of PCIe (Gen 4/5/6) and CXL specifications and implementations",
        "Extensive experience designing and implementing Network-on-Chip architectures",
        "Proficiency in SystemVerilog and UVM for architecture modeling and verification",
        "Strong understanding of SoC performance analysis and optimization techniques",
        "Experience with cache coherency protocols and memory subsystem design",
        "Demonstrated ability to lead complex architectural decisions and trade-offs"
    ],
    expertiseList: [
        "Experience with PCIe and CXL switch design and implementation is an added advantage",
        "Experience with CXL 2.0/3.0 implementation and memory semantics",
        "Familiarity with emerging interface standards (UCIe, CCIX)",
        "Knowledge of AI/ML accelerator integration with high-speed interfaces",
        "Experience designing multi-die systems using advanced packaging technologies",
        "Expertise in power optimization techniques for complex SoCs",
        "Contribution to industry standards committees or publications",
        "Experience with high-performance computing, data center, or networking applications"
    ]
    },
    {
        role: "RTL Designer",
        locations: "India (Bhubaneswar), Philippines (Manila), Singapore, USA (Milpitas), Malaysia (Pinang)",
        qualifications: "BE/ BTech/ MTech/MS/ PhD",
        disciplines: "Electronics, Electrical, Computer Engineering or Computer Science Engineering",
        experience: "2 – 10 Years",
        modalIds: {
            jobDescriptionId: "DigitalJD2",
            expertiseModalId: "DigitalPE2",
        },
        summary: `Highly motivated RTL Designer with experience in developing architecture and micro-architecture for complex digital and mixed-signal SoCs. Ideal candidate should be adept at design sign-off and aligning with power-performance-area goals.`,
        responsibilities: [
            "Highly motivated and driven to face the challenging design problems",
            "Architecture and Micro-architecture of complex digital SoCs and mixed signal SoCs",
            "Communicate with system architects and decipher system requirements to develop architectural specifications of the SoC",
            "Understand future market requirements and develop micro-architecture that supports multiple generations of silicon",
            "Micro-architect the chip with consideration for low power and high-performance techniques",
            "Complete sign-off GDSII working with DV, DFT and PD engineering teams",
            "Comprehend usual service level agreement features – Power, Performance, Area, and Customer Schedule, and plan development accordingly"
        ],
        qualificationsList: [
            "Experience in SoC architecture and micro-architecture development",
            "Strong foundation in digital design concepts and low power design techniques",
            "Hands-on experience with RTL coding, verification, and synthesis",
            "Ability to collaborate with cross-functional engineering teams",
            "Good communication and documentation skills"
        ],
        expertiseList: [
            "Architecting, micro-architecting and designing SoCs for embedded processors for storage, IoT, security and compute applications",
            "Protocol/System knowledge: PCIe, CXL, UCIe, NVMe, USB4.0, DDR, AXI, CHI, AHB, RISC-V",
            "Knowledge in functional safety, power management, coherency, and security",
            "Design Techniques – Low-power, UPF, Clock Domain Crossing (CDC), Booting/Reset Flow",
            "Experience in SW and/or hardware validation",
            "Proficiency in scripting languages such as Shell scripting, Python, TCL, PERL"
        ]
    },
    {
        role: "Design Verification (DV) Engineer",
        locations: "India (Bhubaneswar), Philippines (Manila), Singapore, USA (Milpitas) and Malaysia (Pinang)",
        qualifications: "BE/ BTech/ MTech/MS/ PhD",
        disciplines: "Electronics, Electrical, Computer Engineering or Computer Science Engineering",
        experience: "5 – 10 Years",
        modalIds: {
        jobDescriptionId: "DigitalJD3",
        expertiseModalId: "DigitalPE3"
        },
        summary: `We are seeking a highly motivated and experienced DV Engineer to develop complex pre-silicon verification environments and contribute to SoC development across simulation and emulation platforms.`,
        responsibilities: [
        "Highly motivated and driven to face the challenging SoC verification",
        "Development of Complex Pre-Silicon Verification environments for simulation and Emulation platform",
        "Developing test cases from scratch, coverage plan",
        "Work directly with hardware architects, logic designers, IP providers, Physical implementers and Platform validators to influence overall SoC and system design",
        "Developing System C/ C++ models"
        ],
        qualificationsList: [],
        expertiseList: [
        "Verifying SOC for embedded processors for storage, IoT, security and compute applications",
        "Functional safety, power management, coherency, security",
        "IP/SoC Verification, ASIC Verification, CPU (Multiple) Verification",
        "Formal Verification",
        "One or more of Protocol/System knowledge - PCIe, NVMe, USB4.0, DDR, AXI, CHI, AHB, MIPI, RISC-V",
        "Verification for CDC, Power, Booting/Reset",
        "SystemVerilog/UVM environment",
        "Scripting Languages – Shell scripting, Python, TCL, PERL etc."
        ]
    },
    {
        role: "Physical Design Engineer",
        locations: "India (Bhubaneswar), Philippines (Manila)",
        qualifications: "BE / BTech / MTech / MS / PhD",
        disciplines: "Electronics, Electrical, Computer Engineering or Computer Science Engineering",
        experience: "2 – 10 Years",
        modalIds: {
        jobDescriptionId: "DigitalJD4",
        expertiseModalId: "DigitalPE4"
        },
        summary: `We are seeking a skilled Physical Design Engineer to take on the implementation of netlist-to-GDSII processes, including all aspects of floorplanning, place-and-route, timing closure, and physical verification for advanced technology nodes.`,
        responsibilities: [
        "Implement netlist-to-GDSII for full chip floorplan, global routing, timing optimization, PnR, STA, signal and power integrity analyses, and physical verification.",
        "Collaborate with RTL, analog, and DFT design teams to address physical design issues and develop solutions.",
        "Develop scripts/methodologies for efficient EDA tool usage.",
        "Automate various physical design processes using TCL, Shell, Perl, or Python.",
        "Align development with SLA parameters – performance, area, schedule, and cost."
        ],
        qualificationsList: [
        "Bachelor's, Master's, or PhD in relevant engineering disciplines.",
        "Solid understanding of physical design concepts and flows."
        ],
        expertiseList: [
        "Setting up library and PDK environments.",
        "Chip and block level floorplanning and IO placement.",
        "Place-and-route using standard tools.",
        "Clock and reset tree synthesis for global signals.",
        "Clean routing and RC extraction.",
        "Static timing analysis in multi-mode/multi-corner.",
        "Physical verification (LVS/DRC/ERC/EMIR).",
        "Power/IR analysis.",
        "Logic synthesis and equivalence checks.",
        "Expert user of Synopsys (ICC2/DC/PT/STAR-RC) and Cadence (EDI/Innovus/Voltus) tools.",
        "Experience with P&R, timing closure, and verification on advanced technology nodes."
        ]
    },
    {
        role: "DFT Engineer Lead",
        locations: "India (Bhubaneswar / Bangalore), Philippines (Manila), Singapore and Malaysia (Pinang)",
        qualifications: "BE/ BTech/ MTech/MS/ PhD",
        disciplines: "Electronics, Electrical, Computer Engineering or Computer Science Engineering",
        experience: "8+ Years",
        modalIds: {
            jobDescriptionId: "DigitalJD5",
            expertiseModalId: "", // No separate expertise modal in your sample
        },
        summary: `Highly motivated and driven engineer with strong knowledge in DFT methodologies, scan insertion, ATPG, and hands-on experience with various industry tools. Will work across cross-functional teams to ensure high-quality manufacturability and test coverage.`,
        responsibilities: [
            "Highly motivated and driven to face challenging design and debug problems",
            "In-depth knowledge and hands-on experience in scan insertion, ATPG, coverage analysis, and Transition delay test coverage analysis",
            "Analyse the design and propose the best compression technique",
            "Work with front-end team, DFT and cross-functional teams to provide the solutions and make sure DFT DRCs are fixed",
            "Generating high-quality manufacturing ATPG test patterns for (SAF) stuck-at, transition fault (TDF), Path Delay fault (PDF) models and using on-chip test compression techniques",
            "In-depth knowledge and hands-on experience in Scan insertion and validation, BIST, LBIST, MBIST insertion and verification, ATPG, IP tests and Pattern Validation w/wo Timing, DFT mode timing analysis, and sign-off",
            "Hands-on experience in various DFT aspects like Scan insertion, MBIST and Boundary Scan, ATPG, Pattern validation at block level as well as Full-chip level",
            "Tessent DFT expertise – methodology and flow development",
            "Working experience in Synopsis TetraMax/DFTMax and Cadence Encounter Test is desired",
            "Scripting Languages – Shell scripting, Python, TCL, PERL etc.",
            "Be able to work and support with Test Engineers for post-silicon tasks"
        ],
        qualificationsList: [],
        expertiseList: []
    },
    {
        role: "SystemC Modeling Engineer",
        locations: "India (Bhubaneswar), Philippines (Manila)",
        qualifications: "Candidate should possess Degree in Computer Science, Computer Engineering, Electronics Engineering or a related field",
        disciplines: "Electronics, Electrical, Computer Engineering or Computer Science Engineering",
        experience: "5+ Years",
        modalIds: {
            jobDescriptionId: "DigitalJD6",
            expertiseModalId: "DigitalPE6",
        },
        summary: `Responsible for the design, development, and verification of SystemC models for digital logic circuits and systems. Collaborates with engineering teams to ensure accurate simulation, verification, and documentation.`,
        responsibilities: [
            "Responsible for the design, development, and verification of SystemC models for digital logic circuits and systems",
            "Creates and maintains detailed design specifications, developing efficient and accurate SystemC models, and performing functional and timing simulation and verification",
            "Collaborate with other engineers to understand requirements and design constraints",
            "Write and maintain documentation for models and simulation results",
            "Debug and troubleshoot model issues",
            "Participate in code reviews and contribute to the development of best practices",
            "Continuously improve the capabilities and efficiency of the models"
        ],
        qualificationsList: [],
        expertiseList: [
            "Proficient in C++ and object-oriented programming",
            "Experience with SystemC modeling and simulation",
            "Strong understanding of digital logic and system-on-chip (SoC) design",
            "Excellent interpersonal and analytical skills with the ability to work independently",
            "Must possess good interpersonal skills and can work between multiple departments in carrying out this position’s duties",
            "Knowledge of RTL design (Verilog/VHDL) is a plus"
        ]
    }
];

export default jobData;
